import { useState } from 'react';
import { studioBOn } from '@/lib/studioB/flag';
import { useVideoWorkspaceStore } from '@/stores/videoWorkspaceStore';
import { activeSlideIn, withoutActiveSlide } from './systemContext';

export type SceneScope = { number: number | null; title: string; onRemove: () => void };

/**
 * Direction B: the scene on the stage that Ivy's next message is about, read from the context that is sent, so the
 * chip shows exactly what she gets. Removing it sends the same context without the scene; picking another scene
 * brings the chip back.
 */
export function useSceneScope(systemContext?: string): { context?: string; scene: SceneScope | null } {
  const active = activeSlideIn(systemContext);
  const slides = useVideoWorkspaceStore((s) => s.slides);
  const [removed, setRemoved] = useState<string | null>(null);
  const [seen, setSeen] = useState(active?.id ?? null);
  if ((active?.id ?? null) !== seen) {
    setSeen(active?.id ?? null);
    setRemoved(null);
  }
  if (!studioBOn() || !active || !systemContext) return { context: systemContext, scene: null };
  if (removed === active.id) return { context: withoutActiveSlide(systemContext), scene: null };
  const place = slides.findIndex((s) => s.id === active.id);
  return { context: systemContext, scene: { number: place >= 0 ? place + 1 : null, title: active.title, onRemove: () => setRemoved(active.id) } };
}
